import AuthService from '@/services/AuthService';
import UsuariosService from '@/services/UsuariosService';
import IziToastExternal from '@/utils/iziToastExternal';

const initialState = {
  id_hexa: undefined,
  uid: null,
  nome: '',
  sobrenome: '',
  email: '',
  desativado: false,
  profile_picture: ''
};

const state = {
  user: initialState,
  tour: []
};

const getters = {
  getUser: (state) => state.user,
  getUserIdHexa: (state) => state.user.id_hexa,
  getUserUid: (state) => state.user.uid,
  getUserNome: (state) => state.user.nome,
  getUserSobrenome: (state) => state.user.sobrenome,
  getUserEmail: (state) => state.user.email,
  getUserDesativado: (state) => state.user.desativado,
  getUserProfilePicture: (state) => state.user.profile_picture,
  getUserIsManager: (state, getters) => {
    const toolsReleasedToUser = getters.getModulosPerfisLiberados.ferramentas_liberadas;
    const index = toolsReleasedToUser.findIndex(({ nome, status }) => nome === 'Usuários' && status);
    return index >= 0;
  },
  getTourInfo: (state) => state.tour
};

const actions = {
  setUser({ commit }, value) {
    commit('SET_USER', value);
  },

  setTour({ commit }, value) {
    commit('SET_TOUR', value);
  },

  async login({ commit }, value) {
    const { email, password } = value;
    const user = await AuthService.login(email, password);
    commit('SET_USER', user);
  },

  async loginOidcCopel({ commit }, value) {
    const user = await AuthService.loginOidcCopel(value);
    commit('SET_USER', user);
  },

  async logout() {
    AuthService.logout();
  },

  setUserIdHexaToVuex({ commit, state }) {
    return new Promise((resolve, reject) => {
      UsuariosService.getUsuarioByUid(state.user.uid)
        .then((response) => {
          if (response.data.usuario.perfil.status == false) {
            IziToastExternal.error(`O perfil ${response.data.usuario.perfil.perfil} está inativo.`, '', {
              position: 'topRight',
              timeout: 2500,
              onClosed: () => {
                AuthService.logout();
                reject(true);
              }
            });
            reject(true);
          } else {
            commit('SET_USER_ID_HEXA', response.data.usuario.id);
            resolve(true);
          }
        })
        .catch((e) => {
          console.error('Erro ao executar função setUserIdHexaToVuex: ', e);
          IziToastExternal.error('Falha ao resgatar dados do usuário - 1.2', '', {
            position: 'topRight',
            timeout: 1000,
            onClosed: () => {
              AuthService.logout();
              reject(true);
            }
          });
        });
    });
  },

  resetUserModule({ commit }) {
    commit('SET_USER', initialState);
    commit('SET_TOUR', []);
  }
};

const mutations = {
  SET_USER: (state, value) => (state.user = value),
  SET_TOUR: (state, value) => (state.tour = value),
  SET_USER_ID_HEXA: (state, value) => (state.user.id_hexa = value)
};

export default {
  state,
  getters,
  actions,
  mutations
};
